export var DEFAULT_FORMAT = 'HH:mm:ss';
export function getTimeOption(props) {
    var _a = props.format, format = _a === void 0 ? DEFAULT_FORMAT : _a;
    var hasHour = format.includes('H') || format.includes('h');
    var hasMinute = format.includes('m');
    var hasSecond = format.includes('s');
    var use12Hours = hasHour && format.includes('h');
    return { hasHour: hasHour, hasMinute: hasMinute, hasSecond: hasSecond, use12Hours: use12Hours };
}
